import * as React from "react";
import { forwardRef } from "react";
const SvgProximityObjectIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M36.58,9.25,21,.27a2.06,2.06,0,0,0-2,0l-15.56,9a2,2,0,0,0-1,1.77V29a2,2,0,0,0,1,1.77l15.56,9a2.06,2.06,0,0,0,2,0l15.56-9a2,2,0,0,0,1-1.77V11A2,2,0,0,0,36.58,9.25ZM20,2h0l14.63,8.45L20,18.8,5.41,10.46ZM4.44,29V12.24L19,20.56V37.38ZM21,37.38V20.57l14.54-8.28V29Z" }));
const ForwardRef = forwardRef(SvgProximityObjectIcon);
export { ForwardRef as ReactComponent };
